import { type HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLVideoElement> & {
    src: string,
    width?: number,
    height?: number,
    className?: string,
    style?: React.CSSProperties,
};

export default function({ width, height, src, className, style, ...rest }: Props): React.JSX.Element {
    return <video {...rest} width={width ?? "1024"} height={height ?? "768"} preload="auto" className={className ?? ""} loop disablePictureInPicture autoPlay={true} muted={true} style={style ?? {}}>
        <source src={src} type="video/mp4" />
    </video>
}
